import { createSlice } from "@reduxjs/toolkit";

const userTypeSlice = createSlice({
  name: "userType",
  initialState: "user", // default value
  reducers: {
    setUserType: (_, action) => action.payload,
    resetUserType: () => "user", // resets to default
  },
});

export const { setUserType, resetUserType } = userTypeSlice.actions;
export default userTypeSlice.reducer;